/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
    };

    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          spaceBetween: 20,
          loop: true,
          slidesPerView: 1,
          navigation: {
            prevEl: this.querySelector('.swiper-arrow--prev'),
            nextEl: this.querySelector('.swiper-arrow--next'),
          },
          breakpoints: {
            750: {
              slidesPerView: 2
            },
            990: {
              slidesPerView: 3.3
            }
          }
        },
      },
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!!this.settings.elements.slider) {
      this.settings.instances.slider = new Swiper(
        this.settings.elements.slider,
        this.settings.options.slider,
      );
    }
  }
}

customElements.define('testimonials-slider', TestimonialsSlider);
